import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const ContactContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(5, 2), // Reduced padding overall
    position: 'relative',
    backgroundColor: 'rgba(46, 54, 73, 0.6)',
    backdropFilter: 'blur(15px)',
    borderRadius: '16px',
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(10, 4), // Restore larger padding on medium screens and up
    },
}));

export const ContactForm = styled(Box)(({ theme }) => ({
    padding: theme.spacing(4),
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
    backgroundColor: 'rgba(26, 35, 54, 0.6)',
}));

export const ContactInfo = styled(Box)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(0, 2),
    },
}));
